import { useCallback } from 'react'
import { useIntl } from 'react-intl'
// HACK We import translations to force Storybook refresh when editing translation .json files
// eslint-disable-next-line no-unused-vars
import translations from '../i18n/messages'

const useTranslations = () => {
  const intl = useIntl()

  const t = useCallback(
    (key, values = {}) =>
      intl.formatMessage({ id: key, defaultMessage: key }, values),
    [intl],
  )

  return t
}

export default useTranslations
